var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadPdfOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2214_2219)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86211 0.446289H2.96274C2.03085 0.446295 1.27541 1.19549 1.2754 2.12738L1.27539 14.1831C1.27539 15.115 2.03084 15.8705 2.96273 15.8705L12.4058 15.8705L12.4058 15.1205L2.96274 15.1205C2.44505 15.1205 2.02539 14.7008 2.02539 14.1831L2.0254 2.12738C2.02541 1.6097 2.44506 1.19004 2.96274 1.19004L8.02134 1.19001V5.81151H12.6422V10.7447H13.3821V4.98291L8.86211 0.446289ZM12.4058 5.06151L8.77134 1.42223V5.06151H12.4058Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.17295 11.6904C3.86593 12.0062 3.89732 12.3737 4.13886 12.5947C4.44739 12.8768 4.87197 12.8351 5.25382 12.5144C5.70978 12.1314 6.02096 11.602 6.18631 11.3207C6.19816 11.3005 6.20926 11.2816 6.21961 11.2642C6.21961 11.2642 6.88023 11.0059 7.31686 10.8657C7.72774 10.7337 8.38433 10.5632 8.38433 10.5632C8.785 10.8463 9.21087 11.0686 9.79353 11.0847C10.6154 11.1075 10.773 10.7135 10.773 10.379C10.773 9.97047 10.3668 9.73384 9.98596 9.7032C9.5029 9.66433 9.08544 9.72068 8.54503 9.82926C8.10327 9.46307 7.67751 8.89056 7.4209 8.45091C7.67457 7.60061 7.6665 7.05528 7.63877 6.84348C7.57319 6.34276 7.25813 6.10491 6.86715 6.14073C6.28856 6.19373 6.16803 6.7112 6.20561 7.11588C6.25444 7.6419 6.49198 8.17165 6.68863 8.54012C6.68863 8.54012 6.4584 9.21094 6.28191 9.63089C6.09932 10.0653 5.74809 10.7266 5.74809 10.7266L5.73362 10.7331C5.50433 10.8355 5.21439 10.9651 4.91982 11.14C4.63308 11.3103 4.37823 11.4792 4.17295 11.6904ZM7.75779 10.0171C7.75779 10.0171 7.56262 9.81041 7.44622 9.6705C7.32413 9.52376 7.14895 9.28249 7.14895 9.28249C7.14895 9.28249 7.02548 9.60655 6.93965 9.81146C6.84586 10.0354 6.7024 10.3469 6.7024 10.3469C6.7024 10.3469 7.02123 10.2369 7.22762 10.1724C7.43347 10.1081 7.75779 10.0171 7.75779 10.0171Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8327 10.4866H13.6588V13.4562H14.7295L12.7722 15.8032L10.7729 13.4562H11.8327V10.4866Z",
    stroke: "currentColor",
    strokeWidth: 0.75
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2214_2219"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.446289)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdfOutline);
export default __webpack_public_path__ + "static/media/download-pdf-outline.ad6ade315956968d9d088faf686d53c7.svg";
export { ForwardRef as ReactComponent };